<template>
  <div class="page-sidebar-wrapper">
    <div class="page-sidebar navbar-collapse collapse">
      <ul class="page-sidebar-menu  page-header-fixed page-sidebar-menu-hover-submenu page-sidebar-menu-closed"
          data-keep-expanded="false" data-auto-scroll="true" data-slide-speed="200">
        <router-link to="/admin/dashboard" tag="li" active-class="active" class="nav-item start">
          <a class="nav-link active">
            <i class="icon-home activ"></i>
            <span class="selected"></span>
            <span class="title">Home</span>
          </a>
        </router-link>
        <li class="nav-item" v-bind:class="activeChild()"
            v-if="user.organizations.length > 1 || user.access > 4">
          <a href="#" class="nav-link nav-toggle">
            <i class="icon-settings"></i>
            <span class="selected"></span>
            <span class="title">Administrative Settings</span>
            <span class="arrow"></span>
          </a>
          <ul class="sub-menu">
            <router-link :to="{ name: 'View As' }" tag="li" active-class="active" class="nav-item"
                         v-if="user.organizations.length > 1 || user.access > 5">
              <a class="nav-link">
                <span class="title">View As</span>
              </a>
            </router-link>
            <router-link :to="{ name: 'Manage Account List' }" tag="li" active-class="active"
                         class="nav-item"
                         v-if="user.access > 5">
              <a class="nav-link">
                <span class="title">Manage Accounts</span>
              </a>
            </router-link>
            <router-link :to="{ name: 'Manage Users' }" tag="li" active-class="active" class="nav-item"
                         v-if="user.access > 4">
              <a class="nav-link">
                <span class="title">Manage Users</span>
              </a>
            </router-link>
            <router-link :to="{ name: 'Form Builder Index' }" tag="li" active-class="active"
                         class="nav-item"
                         v-if="user.access > 4">
              <a class="nav-link">
                <span class="title">Form Builder</span>
              </a>
            </router-link>
            <router-link :to="{ name: 'Imports Select' }" tag="li" active-class="active" class="nav-item"
                         v-if="user.access > 4">
              <a class="nav-link ">
                <span class="title">Data Import</span>
              </a>
            </router-link>

            <li class="nav-item" v-if="user.access > 5">
              <a class="nav-link">
                                <span class="title">General Settings <i
                                  class="pull-right fa fa-chevron-right"></i></span>
              </a>

              <ul class="sub-menu">
                <router-link :to="{ name: 'General Settings' }" tag="li" active-class="active"
                             class="nav-item"
                             v-if="user.access > 5">
                  <a class="nav-link">
                    <span class="title">Maintenance Mode</span>
                  </a>
                </router-link>

              </ul>
            </li>
            <router-link :to="{ name: 'Email Settings' }" tag="li" active-class="active" class="nav-item"
                         v-if="user.access > 4">
              <a class="nav-link">
                <span class="title">Email Settings</span>
              </a>
            </router-link>
          </ul>
        </li>
        <li class="nav-item" v-bind:class="activeChildDirectory()" v-if="user.access > 1">
          <a href="#" class="nav-link nav-toggle">
            <i class="icon-user"></i>
            <span class="title">Directory</span>
            <span class="selected"></span>
            <span class="arrow"></span>
          </a>
          <ul class="sub-menu">
            <router-link :to="{ name: 'Participant Directory' }" tag="li" active-class="active"
                         class="nav-item">
              <a class="nav-link">
                <span class="title">{{ participantSingularName }} Directory</span>
              </a>
            </router-link>
            <li v-if="user.access > 2" class="nav-item" @click="showAddUserModal">
              <a class="nav-link">
                                <span class="title"><i class="fa fa-plus"
                                                       aria-hidden="true"></i> Add New {{ participantSingularName }}</span>
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-bind:class="activeChildWorkspace()" v-if="user.access > 1">
          <a href="#" class="nav-link nav-toggle">
            <i class="icon-share"></i>
            <span class="title">Workspace</span>
            <span class="selected"></span>
            <span class="arrow"></span>
          </a>
          <ul class="sub-menu">
            <router-link v-if="user.access > 2" :to="{ name: 'Workspace' }" tag="li" active-class="active"
                         class="nav-item">
              <a class="nav-link">
                <span class="title">Organization Forms</span>
              </a>
            </router-link>
            <router-link v-if="user.access > 2" :to="{ name: 'Shared files' }" tag="li" active-class="active"
                         class="nav-item">
              <a class="nav-link">
                <span class="title">Shared Files</span>
              </a>
            </router-link>
            <router-link v-if="user.access > 5" :to="{ name: 'Public files' }" tag="li" active-class="active"
                         class="nav-item">
              <a class="nav-link">
                <span class="title">Public Files</span>
              </a>
            </router-link>
          </ul>
        </li>
        <router-link :to="{ name: 'Reports Index', params: {'reset':true }}" tag="li" active-class="active"
                     class="nav-item"
                     v-if="user.access > 2">
          <a href="#" class="nav-link nav-toggle">
            <i class="fa fa-line-chart" aria-hidden="true"></i>
            <span class="title">Reports</span>
            <span class="arrow"></span>
          </a>
          <ul class="sub-menu hide">

          </ul>
        </router-link>
        <li class="nav-item" v-if="user.access > 1" :class="activeGroups()">
          <a href="#" class="nav-link nav-toggle">
            <i class="icon-docs"></i>
            <span class="title">Groups</span>
            <span class="selected"></span>
            <span class="arrow"></span>
          </a>
          <ul class="sub-menu">
            <router-link :to="{ name: 'Groups Forms' }" tag="li" active-class="active" class="nav-item">
              <a class="nav-link">
                <span class="title">Activities and Services</span>
              </a>
            </router-link>
            <router-link :to="{ name: 'Messaging Home' }" tag="li" active-class="active" class="nav-item"
                         v-if="user.access > 1 && user.twilioStatus">
              <a class="nav-link">
                <span class="title">Messaging</span>
              </a>
            </router-link>
          </ul>
        </li>
        <router-link :to="{ name: 'Referral Dashboard' }" tag="li" active-class="active" class="nav-item"
                     v-if="user.access >= 3">
          <a class="nav-link nav-toggle">
            <i class="icon-users"></i>
            <span class="title">Referral/Application Dashboard</span>
            <span class="arrow"></span>
          </a>
          <ul class="sub-menu">
          </ul>
        </router-link>
        <router-link :to="{ name: 'Calendar' }" tag="li" active-class="active" class="nav-item"
                     v-if="user.access > 2">
          <a class="nav-link nav-toggle">
            <i class="icon-calendar"></i>
            <span class="title">Scheduling</span>
            <span class="arrow"></span>
          </a>
          <ul class="sub-menu">
          </ul>
        </router-link>
        <router-link :to="{ name: 'Messages', params: { id: $route.params.id } }" tag="li" active-class="active"
                     class="nav-item" :class="activeMessages()"
                     v-if="showLink && user.access > 1 && user.twilioStatus">
          <a class="nav-link nav-toggle">
            <i class="icon-bubbles"></i>
            <span class="title">Messaging</span>
            <span class="arrow"></span>
          </a>
        </router-link>
        <router-link :to="{ name: 'Activities and Services', params: { id: $route.params.id } }" tag="li"
                     active-class="active" class="nav-item" :class="activeActivities()"
                     v-if="showLink && user.access > 1" @click.native="emitCancel">
          <a class="nav-link nav-toggle">
            <i class="icon-puzzle"></i>
            <span class="selected"></span>
            <span class="title">Activities & Services</span>
            <span class="arrow"></span>
          </a>
        </router-link>
        <router-link :to="{ name: 'Assessment and Outcomes', params: { id: $route.params.id } }" tag="li"
                     active-class="active" class="nav-item" :class="activeAssessments()"
                     v-if="showLink && user.access > 1" @click.native="emitCancel">
          <a class="nav-link nav-toggle">
            <i class="icon-folder"></i>
            <span class="selected"></span>
            <span class="title">Assessments & Outcomes</span>
            <span class="arrow"></span>
          </a>
        </router-link>

        <li class="nav-item" v-if="user.access > 1" :class="activeSupport()">
          <a href="#" class="nav-link nav-toggle">
            <i class="icon-question"></i>
            <span class="title">Support</span>
            <span class="selected"></span>
            <span class="arrow"></span>
          </a>

          <ul class="sub-menu">
            <router-link :to="{ name: 'Contact' }" tag="li" active-class="active" class="nav-item">
              <a class="nav-link">
                <span class="title">Contact</span>
              </a>
            </router-link>
            <router-link :to="{ name: 'FAQ' }" tag="li" active-class="active" class="nav-item">
              <a class="nav-link">
                <span class="title">FAQ</span>
              </a>
            </router-link>
            <router-link :to="{ name: 'Help and Tutorials' }" tag="li" active-class="active" class="nav-item">
              <a class="nav-link">
                <span class="title">Help and Tutorials</span>
              </a>
            </router-link>
          </ul>
        </li>
      </ul>
    </div>
    <add-user-search-modal :refresh="refreshAddUserModal"></add-user-search-modal>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {EventBus} from '@/event-bus.js';
import AddUserSearchModal from "@/components/modals/AddUserSearchModal";
import participantDisplayName from '@/mixins/participantDisplayName';

export default {
  name: 'page-sidebar-wrapper',
  mixins: [
    participantDisplayName
  ],
  components: {AddUserSearchModal},
  data() {
    return {
      msg: 'Test',
      refreshAddUserModal: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      participant: 'getParticipant'
    }),
    showLink() {
      if(this.$route.name === 'Referral Dashboard') {
        return false;
      } else {
        return !['Form Builder Index', 'Form Builder Edit', 'Message History Details'].includes(this.$route.name)
          && this.$route.params.id != null
          && (this.participant.assignment != null
            && this.participant['assignment'].length !== 0);
      }
    },
  },
  methods: {
    activeChild() {
      return {
        'active': ['Form Builder Index', 'Form Builder Edit', 'Manage Account List', 'Manage Users', 'Manage Account Referral', 'Manage Account Add Referral', 'Manage Account Edit Referral', 'Manage Account CaseMGR', 'Manage Account Add CaseMGR', 'Manage Account Edit CaseMGR', 'General Settings'].includes(this.$route.name)
      }
    },
    activeChildDirectory() {
      return {
        'active': ['Participant Page', 'Participant Edit', 'Participant Directory', 'Participant Directory Search', 'Participant History'].includes(this.$route.name)
      }
    },
    activeChildWorkspace() {
      return {
        'active': ['Workspace', 'Organization Forms'].includes(this.$route.name)
      }
    },
    activeActivities() {
      return {
        'active': ['Activities and Services', 'Activities and Services Edit'].includes(this.$route.name)
      }
    },
    activeAssessments() {
      return {
        'active': ['Assessment and Outcomes', 'Assessment and Outcomes Edit'].includes(this.$route.name)
      }
    },
    activeMessages() {
      return {
        'active': ['Messages'].includes(this.$route.name)
      }
    },
    activeGroups() {
      return {
        'active': ['Groups Forms', 'Messaging Home'].includes(this.$route.name)
      }
    },
    activeSupport() {
      return {
        'active': ['Contact', 'FAQ', 'Help and Tutorials'].includes(this.$route.name)
      }
    },
    emitCancel() {
      EventBus.$emit('cancel', true);
    },
    showAddUserModal() {
      this.refreshAddUserModal = !this.refreshAddUserModal;
      $('#add-user-search-modal').modal('show');
    }
  }
}
</script>
<style scoped lang="scss">
.nav-item .fa-chevron-right {
  line-height: 1.8em;
  font-size: 0.8em;
  float: right;
}

.nav-link.nav-toggle {
  white-space: nowrap;
}
.page-sidebar .page-sidebar-menu {
  margin-bottom: 0;
}
.page-sidebar-closed .page-sidebar .page-sidebar-menu.page-sidebar-menu-closed > li:hover {
  width: 270px !important;
  box-shadow: none;
  position: relative;

  > a {
    z-index: 1;
  }

  &:after {
    content: ' ';
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin-left: 54px;
    box-shadow: 5px 5px rgba(48, 48, 48, 0.2);
    position: absolute;
    z-index: 0;
  }
}
.page-sidebar-closed .page-sidebar .page-sidebar-menu.page-sidebar-menu-closed > li:hover > .sub-menu {
  width: 215px;
}
.page-sidebar-menu.page-sidebar-menu-hover-submenu li .sub-menu > li > a {
  margin: 0;
  padding: 12px 18px;
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?8a2c6f62